export const API_ENDPOINT = 'https://api.bijeljinaput.com';
